import { getBannerConfiguration } from "../../action/notification/banner-config";
import { v4 as uuidv4 } from 'uuid';
import { getAvatar } from '../../action/avatar/getAvatar';
import { frontEndLogs } from '../../action/logs/frontEndLogs';

export const getSessionIdFromStorage = () => {
    const sessionId = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? sessionStorage.getItem('sessionId') : localStorage.getItem('sessionId');
    return sessionId;
}

export const getEmailFromStorage = () => {
    if (sessionStorage.getItem('actor') && sessionStorage.getItem('actor_email')){
        let email=sessionStorage.getItem('actor_email');
        return email;
    } else {
        let email = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? sessionStorage.getItem('email') : localStorage.getItem('email');
        email = email || '';
        return email;
    }
}

export const getTokenFromStorage = () => {
    let token = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? sessionStorage.getItem('token') : localStorage.getItem('token');
    token = token || '';
    return token;
}

export const getCsrfTokenFromStorage = () => {
    let csrfToken = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? sessionStorage.getItem('csrfToken') : localStorage.getItem('csrfToken');
    csrfToken = csrfToken || '';
    return csrfToken;
}

export const isValidEmail = () => {
   const isEmailValid = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? (sessionStorage.getItem('email') !== undefined && sessionStorage.getItem('email') !== '') : (localStorage.getItem('email') !== undefined && localStorage.getItem('email') !== '');
   return isEmailValid;
}

export const isValidSessionId = () => {
    const isSessionIdValid = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? (sessionStorage.getItem('sessionId') !== '' && sessionStorage.getItem('sessionId') != null) : (localStorage.getItem('sessionId') !== '' && localStorage.getItem('sessionId') != null);
    return isSessionIdValid;
}

export const setSessionIdInStorage = (sessionId) => {

    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.setItem('sessionId', sessionId)
    }
    else {
        localStorage.setItem('sessionId', sessionId)
    }
} 

export const setEmailInStorage = (email) => {
    const fromWhere = localStorage.getItem("fromWhere") || "";
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';

	const emailValue = email ? email.trim().toLowerCase() : '';
    if (sessionStorage.getItem("actor") && sessionStorage.getItem("actor_email")) {
        sessionStorage.setItem("email", emailValue);
    } else if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.setItem("email", emailValue);
    } else {
        localStorage.setItem("email", emailValue);
    }
}

export const setTokenInStorage = (token) => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.setItem('token', token)
    }
    else {
        localStorage.setItem('token', token)
    }
}

export const setCsrfTokenInStorage = (csrfToken) => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.setItem('csrfToken', csrfToken)
    }
    else {
        localStorage.setItem('csrfToken', csrfToken)
    }
}

export const removeSessionIdFromStorage = () => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.removeItem('sessionId')
    }
    else {
        localStorage.removeItem('sessionId')
    }
}

export const removeEmailFromStorage = () => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.removeItem('email')
    }
    else {
        localStorage.removeItem('email')
    }

}

export const removeTokenFromStorage = () => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.removeItem('token')
    }
    else {
        localStorage.removeItem('token')
    }
}

export const removeCsrfTokenFromStorage = () => {
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (fromWhere === 'apply_now' || sessionFromwhere === 'apply_now') {
        sessionStorage.removeItem('csrfToken')
    }
    else {
        localStorage.removeItem('csrfToken')
    }
}

export const generateUuid = () => {
    const broker = window.location.search.includes('broker');
    if (!sessionStorage.getItem('uuid') && !broker) {
        const UUID = uuidv4();
        sessionStorage.setItem('uuid', UUID);
    }
}

export const extractEmails = (text) => {
    return text.match(/(?=([a-z0-9._%+-]+))\1@(?=([a-z0-9-]+))\2\.(?=([a-z]{2,}))\3/gi);
}

export const getActorFromSession = () => {
    return sessionStorage.getItem("actor") || "";
}

export const setAdminEmailInStorage = (email) => {
    localStorage.setItem("admin_email", email);
};

export const getAdminEmailInStorage = () => {
    return localStorage.getItem("admin_email") || "";
}

export const getUserContext = () => {
	const actor = getActorFromSession();
	if (actor) {
		return { actor };
	}
	else {
		return { email: getEmailFromStorage() }
	}
}
export const setUserDetails = async (setUserName, setProfilePic) => {
    const isUserDetailsAvailable = sessionStorage.getItem('isDetailsSet');
    const fromWhere = localStorage.getItem('fromWhere') || '';
    const sessionFromwhere = sessionStorage.getItem('fromWhere') || '';
    if (isUserDetailsAvailable === 'true' || fromWhere === 'apply_now') {
        return;
    }
    if (isUserDetailsAvailable !== 'true' && (fromWhere !== 'apply_now' || sessionFromwhere !== 'apply_now')) {
        let email = getEmailFromStorage();
        const obj = {
            email: email
        }
        const UserDetailsResult = await getAvatar(obj);
        let mob = UserDetailsResult.data.data.mobile_number;
        let isEmailConsentChecked = UserDetailsResult.data.data.email_marketing_consent;
        let isSMSConsentChecked = UserDetailsResult.data.data.sms_marketing_consent;
        let isMobileAppConsentChecked = UserDetailsResult.data.data.mobile_app_marketing_consent;
        let username = UserDetailsResult.data.data.username;
        let userID = UserDetailsResult.data.data.id;
        if (UserDetailsResult.data.data.image_path) {
            let userPicture = 'data:image/jpeg;base64,' + UserDetailsResult.data.data.image_path
            setProfilePic(userPicture);
        }
        else {
            let userPicture = sessionStorage.getItem("profilePicture");
            if (userPicture != null) {
                setProfilePic(userPicture);
            }
        }
        sessionStorage.setItem('mobileNumber', mob);
        sessionStorage.setItem('UserName', username);
        sessionStorage.setItem('emailConsent', isEmailConsentChecked);
        sessionStorage.setItem('smsConsent', isSMSConsentChecked);
        sessionStorage.setItem('mobileConsent', isMobileAppConsentChecked);
        sessionStorage.setItem('userID', userID);
        setUserName(username);
        return username;
    }
}

export const fetchBannerConfiguration = () => {
    return async (dispatch) => {
        try {
            const response = await getBannerConfiguration();
            const banner = response?.data?.data;

            dispatch({
                type: 'SET_BANNER_ENABLE',
                value: banner?.isBannerEnable ?? false
            });

            dispatch({
                type: 'SET_BANNER_CONTENT',
                value: banner?.bannerContent ?? ''
            });
        }
        catch (error) {
            frontEndLogs('Failed to fetch banner configuration:', true, 400, 'fetchBannerConfiguration', error.message);
        }
    };
};



